import { render, staticRenderFns } from "./approverDraweryh.vue?vue&type=template&id=4a980612&"
import script from "./approverDraweryh.vue?vue&type=script&lang=js&"
export * from "./approverDraweryh.vue?vue&type=script&lang=js&"
import style0 from "./approverDraweryh.vue?vue&type=style&index=0&id=4a980612&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports